import { useMutation } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { WorkspaceJSON } from '../types';
import { WorkspaceQueryInvalidator } from './queryInvalidator';

type Params = {
	workspaceID: number;
	onSuccess?: ( workspace: WorkspaceJSON ) => void;
	onError?: ( error: unknown ) => void;
};

const useRemoveWorkspaceAddOnMutation = ( { workspaceID, onSuccess, onError }: Params ) => {
	const system = useWorkspaceSystem();

	return useMutation(
		async (
			{ addOnPriceID, quantity }: { addOnPriceID: number, quantity: number }
		) => system.removeWorkspaceAddOn( { workspaceID, addOnPriceID, quantity } ),
		{
			onSuccess: ( workspace ) => {
				WorkspaceQueryInvalidator.invalidateMemberAddOnPreview( workspaceID );
				WorkspaceQueryInvalidator.invalidateWorkspaceMembers( workspaceID );
				onSuccess?.( workspace );
			},
			onError
		}
	);
};

export default useRemoveWorkspaceAddOnMutation;
